import { styled } from '@/src/stitches.config'
import Link from 'next/link'

export const MarginTopWrapper = styled('div', { mt: 30 })

export const GiftIdeasWrapper = styled('div', {
    width: '100%',
    display: 'flex',
    gap: '4%',
})

export const GiftIdeaContainer = styled(Link, {
    width: '48%',
    maxWidth: 200,
    textAlign: 'center',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    '.card-image': {
        marginTop: 0,
    },
    '.dateFinal': {
        display: 'none',
    },
})

export const StyledH3 = styled('h3', {
    fontSize: '1rem',
    color: '$dark',
})

export const BrandsWrapper = styled('div', {
    display: 'flex',
    gap: '4%',
    flexWrap: 'wrap',
    '@sm': {
        gap: '2%',
    },
})
